import i18n from 'i18n-js';
import translations from './translations.json';

const en = {};
const be = {};

Object.keys(translations).forEach(key => {
    en[key] = translations[key].en;
    be[key] = translations[key].be;
});

i18n.translations = {
    en: en,
    be: be,
}

i18n.fallbacks = {languageTag: "en", isRTL: false};

export function stringsTranslate(name,vars={}) {
    return i18n.t(name,vars);
}
